import Rout from './Rout/Rout';
import './App.css';

function App() {
  return (
    <div className="App">
     <Rout/>
    </div>
  );
}

export default App;
